import { inject, Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NavigationHandlerHelper implements OnDestroy {
  
  userDestroyed$:                                                  Subject<void> = new Subject<void>();

  /* use inject instead constructor injection */
  private router: Router =                                         inject(Router);
  private msalBroadcastService: MsalBroadcastService =             inject(MsalBroadcastService);

  public setupNavigationHandler() {

    this.msalBroadcastService.msalSubject$
      .pipe( filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS), takeUntil(this.userDestroyed$))
      .subscribe((result: EventMessage) => {
        
        // console.log(result);

        setTimeout(() => {

          this.handlePostLoginNavigation();
        }, 100);
      }
    );
  }

  public handlePostLoginNavigation() {

    const currentUrl = window.location.href;
    const currentHash = window.location.hash;
    const hasHashDuplicate = currentUrl.includes('/#/#') || currentUrl.includes('/index.html#/#');
    const shouldRedirect = hasHashDuplicate || (this.router.url === '/' && currentHash && currentHash !== '#/');
    
    if (shouldRedirect) {
      
      let targetPath = '';
      
      if (currentUrl.includes('/#/#')) {

        const parts = currentUrl.split('/#/#');
        
        if (parts.length > 1) {
        
          targetPath = '/' + parts[1];
        }

      } else if (currentUrl.includes('/index.html#/#')) {

        const parts = currentUrl.split('/index.html#/#');

        if (parts.length > 1) {

          targetPath = '/' + parts[1];
        }

      } else if (currentHash && currentHash !== '#/') {
        targetPath = currentHash.substring(1);
      }
      
      if (targetPath && targetPath !== '/' && targetPath !== this.router.url) {
        
        let cleanUrl = currentUrl;
        
        if (currentUrl.includes('/#/#')) {
        
          cleanUrl = currentUrl.replace('/#/#', '/#');
        
        } else if (currentUrl.includes('/index.html#/#')) {
        
          cleanUrl = currentUrl.replace('/index.html#/#', '/index.html#');
        }
        
        window.history.replaceState(null, '', cleanUrl);
        
        this.router.navigateByUrl(targetPath).then(success => {
          
          /* console.log('Navegación completada:', success); */
        
        }).catch(error => {
        
          console.error('Error en navegación:', error);
        });
      }
    }
  }

  ngOnDestroy(): void {
    
    this.userDestroyed$.next();
    this.userDestroyed$.complete();
  }
}
